import TimeSwitcher from './TimeSwitcher';

export default TimeSwitcher;
